'use client'

import { ErrorScreen, type ErrorScreenProps } from '@/shell'

/**
 * Next.js resolves this file by name, so it is an adapter and owns nothing (ADR 0010).
 * The screen is `shell/error-screen.tsx`.
 */
export default function Error(props: ErrorScreenProps) {
  return <ErrorScreen {...props} />
}
